var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgTv(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M20.375 6.912a2.1 2.1 0 00-.675-.334 6 6 0 00-.72-.17 20 20 0 00-1.896-.231C15.63 6.058 13.81 6 12 6s-3.631.058-5.084.177a20.43 20.43 0 00-1.896.23 6.11 6.11 0 00-.72.171 2.1 2.1 0 00-.675.334c-.216.172-.34.387-.411.531a3 3 0 00-.182.491c-.092.325-.16.714-.212 1.123-.104.824-.153 1.847-.153 2.86 0 1.015.05 2.051.152 2.905.051.426.119.827.207 1.168.075.292.205.706.47 1.009.241.273.574.392.73.443.208.07.45.125.701.17.506.091 1.156.164 1.885.22C8.275 17.945 10.143 18 12 18s3.725-.055 5.188-.168a20 20 0 001.885-.22c.25-.045.493-.1.701-.17.156-.051.489-.17.73-.443.265-.303.395-.717.47-1.01.088-.34.155-.742.207-1.167.103-.854.152-1.89.152-2.905 0-1.013-.05-2.036-.153-2.86a8 8 0 00-.212-1.123 3 3 0 00-.182-.49 1.5 1.5 0 00-.411-.532M6 15h.01",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTv;